module.exports = __webpack_public_path__ + "static/hand-zoom-4bceef4d848b86884ac344471a3a0c51.jpg";